<script setup>
import { useRoute } from "vue-router";
import { useSessionStore } from "@/stores/session";
import SideNav from "./SideNav.vue";
// TODO load these dynamically on demand?
import ConfigurationPage from "./ConfigurationPage.vue";
import DataPage from "./DataPage.vue";
import ChatPage from "./ChatPage.vue";
import MenteesPage from "./MenteesPage.vue";
import MenteeSuggestionPage from "./MenteeSuggestionPage.vue";
import MonitorPage from "./MonitorPage.vue";
import SettingsPage from "./SettingsPage.vue";
import UsersPage from "./UsersPage.vue";
import DebugPanel from "./DebugPanel.vue";

const session = useSessionStore();
const route = useRoute();
</script>

<template>
  <div class="home-page">
    <div class="home-sidenav">
      <SideNav />
    </div>
    <div class="home-content">
      <ChatPage v-if="$route.path == '/chat'" />
      <ConfigurationPage v-else-if="$route.path == '/configuration'" />
      <DataPage v-else-if="$route.path == '/data'" />
      <MenteesPage v-else-if="$route.path == '/mentees'" />
      <MenteeSuggestionPage v-else-if="$route.path == '/menteesuggestion'" />
      <MonitorPage v-else-if="$route.path == '/monitor'" />
      <SettingsPage v-else-if="$route.path == '/settings'" />
      <UsersPage v-else-if="$route.path == '/users'" />
      <div v-else>no content for {{ $route.path }}</div>
    </div>
    <div
      v-if="session.debugPanelOpen && session.rolesIncludes('admin') && (route.path === '/chat' || route.path.startsWith('/chat/'))"
      class="home-debug"
    >
      <DebugPanel :isVisible="true" />
    </div>
  </div>
</template>

<style scoped>
.home-page {
  display: flex;
  height: var(--app-height);
  min-height: 100vh;
  min-height: -webkit-fill-available;
  margin: 0;
  background-color: var(--background-color);
}

.home-sidenav {
  flex: 0 0 auto;
  position: relative;
  display: flex;
  background: var(--background-color);
  padding-top: calc(60px * 1.5);
  height: 100%;
  overflow: hidden;
}

.home-content {
  flex: 1 1 auto;
  position: relative;
  background-color: var(--background-color);
  min-width: 0;
}

.home-debug {
  flex: 0 0 30%;
  height: 100%;
  overflow: hidden;
}
</style>
